/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Sections components
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import { useDispatch } from "react-redux";
import { FormControl, Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Icon from "@mui/material/Icon";
import { useParams } from "react-router-dom";
import analysisCollections from "../../store/constant/analysisCollections";
import MKBox from "../../components/MKBox";
import { ANALYSIS_COLLECTIONS } from "../../store/actions";
// eslint-disable-next-line import/no-cycle
import MainLayout from "../MainLayout";
import MKButton from "../../components/MKButton";
import typography from "../../assets/theme/base/typography";
import MKTypography from "../../components/MKTypography";
import assessments from "../../store/constant/assessments";
import AssessmentCounterCard from "../../views/Cards/CounterCards/AssessmentCounterCard";
import categoryColor from "../../utils/categoryColor";

// Avatars page components
const categories = ["water", "ecology", "agriculture"];
const { size } = typography;
// Avatars page components code

const Assessment = () => {
  const dispatch = useDispatch();
  const { country } = useParams();

  // eslint-disable-next-line no-unused-vars
  const [ReturnCollections, setReturnCollections] = useState([]);
  const Countries = [
    "China",
    "Afghanistan",
    "Nepal",
    "Bhutan",
    "Pakistan",
    "Myanmar",
    "India",
    "Bangladesh",
  ];
  // console.log(ReturnCollections);

  const Times = ["2000", "2010", "2020"];
  const [TimeSelected, setTimeSelected] = useState("2020");
  const handleTimeChange = (event) => {
    setTimeSelected(event.target.value);
  };
  const [CurrentRegion, setCurrentRegion] = useState("HKH Region");

  const BreadcrumbsRoutes = [{ label: "Home", route: "/home" }, { label: "Assessment" }];
  const LeftRef = useRef(null);
  const TopRef = useRef(null);
  const CardRef = useRef(null);
  // const [maxHeight, setMaxHeight] = useState(null);
  const [cardWidth, setCardWidth] = useState(null);
  useLayoutEffect(() => {
    if (LeftRef.current && TopRef.current) {
      // const LeftHeight = LeftRef.current.offsetHeight;
      // const TopHeight = TopRef.current.offsetHeight;
      const GridWidth = CardRef.current.offsetWidth;
      // setMaxHeight(LeftHeight - TopHeight - 16);
      setCardWidth(GridWidth - 48);
    }
  }, [LeftRef, TopRef]);

  useEffect(async () => {
    if (country !== undefined) {
      setCurrentRegion(country);
    }
    setReturnCollections(analysisCollections.collections);
    dispatch({ type: ANALYSIS_COLLECTIONS, value: analysisCollections.collections });
    setReturnCollections(analysisCollections.collections);
  }, []);
  return (
    <MainLayout breadcrumbsRoutes={BreadcrumbsRoutes}>
      <MKBox bgColor="white" component="section" sx={{ height: "87vh", overflow: "auto" }}>
        <Grid2 container>
          <Grid2
            xs={12}
            container
            mx={{ sm: 3, xl: 12, xxl: 24, xxxl: 48 }}
            // mt={{ sm: 3, xl: 6, xxl: 8, xxxl: 12 }}
            maxWidth={1600}
          >
            <Grid2
              xs={2.5}
              sx={{
                background: "#f7f7f7",
                display: "block",
              }}
              ref={LeftRef}
            >
              <MKBox width="100%" position="sticky" top="0px">
                <Grid2 xs={12} sx={{ py: 1 }}>
                  <MKButton
                    variant="text"
                    color={CurrentRegion === "HKH Region" ? "secondary" : "primary"}
                    fullWidth
                    onClick={() => setCurrentRegion("HKH Region")}
                    sx={{
                      backgroundColor: CurrentRegion === "HKH Region" ? "#ffffff" : "none",
                      fontSize: size.xl,
                      textTransform: "capitalize",
                    }}
                  >
                    HKH Region
                  </MKButton>
                </Grid2>
                <Grid2 xs={12} sx={{ py: 1 }}>
                  <MKButton
                    color="primary"
                    variant="text"
                    fullWidth
                    disabled
                    sx={{
                      fontSize: size.xl,
                      textTransform: "capitalize",
                      "&:disabled": {
                        // background: colorValue,
                        color: "primary.focus",
                      },
                    }}
                  >
                    Regional Member Countries
                    <Icon sx={{ verticalAlign: "middle" }}>keyboard_arrow_down</Icon>
                  </MKButton>
                </Grid2>
                {Countries.map((region) => (
                  <Grid2 xs={12} key={region} sx={{ py: 1 }}>
                    <MKButton
                      variant="text"
                      color={CurrentRegion === region ? "secondary" : "primary"}
                      fullWidth
                      onClick={() => setCurrentRegion(region)}
                      sx={{
                        backgroundColor: CurrentRegion === region ? "#ffffff" : "none",
                        fontSize: size.md,
                        textTransform: "capitalize",
                      }}
                    >
                      {region}
                    </MKButton>
                  </Grid2>
                ))}
              </MKBox>
            </Grid2>

            <Grid2
              xs={9.5}
              sx={{
                pl: 4,
                borderColor: ({ palette: { primary }, functions: { rgba } }) =>
                  `${rgba(primary.main, 0.2)}`,
              }}
            >
              <MKBox ref={TopRef}>
                <Grid2
                  container
                  m={1}
                  justifyContent="space-between"
                  sx={{
                    p: 1,
                    backgroundColor: ({ palette: { secondary }, functions: { rgba } }) =>
                      rgba(secondary.main, 0.1),
                    borderRadius: "8px",
                  }}
                >
                  <MKBox display="flex" alignItems="center">
                    <MKTypography variant="subtitle2" sx={{ mx: 1 }}>
                      Time Period:
                    </MKTypography>
                    <FormControl variant="outlined">
                      <Select
                        id="time-period-select"
                        value={TimeSelected}
                        onChange={handleTimeChange}
                      >
                        <MenuItem disabled key="none" value="time series">
                          None
                        </MenuItem>
                        {Times.map((time) => (
                          <MenuItem key={time} value={time}>
                            {time}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </MKBox>
                  <MKBox display="flex" alignItems="center">
                    <MKButton onClick={() => setTimeSelected("time series")}>
                      time series chart
                    </MKButton>
                  </MKBox>
                </Grid2>
              </MKBox>

              <MKBox>
                <Grid2 container spacing={3} mt={1} sx={{ width: 1 }}>
                  {categories.map((category) => (
                    <Grid2 container key={category}>
                      <Grid2 xs={12} display="flex" sx={{ justifyContent: "center" }}>
                        <MKTypography variant="h3" textTransform="capitalize">
                          {category}
                        </MKTypography>
                      </Grid2>
                      <Grid2 container>
                        {assessments
                          .filter((a) => a.category === category)
                          .map(({ id, description, title, assessment, decimal, suffix }, index) => (
                            <Grid2 xs={6} key={id} ref={CardRef}>
                              {TimeSelected === "time series" ? (
                                <AssessmentCounterCard
                                  category={category}
                                  title={title}
                                  decimals={decimal}
                                  suffix={suffix}
                                  description={description}
                                  high
                                  chart={assessment.filter((a) => a.region === CurrentRegion)}
                                  width={cardWidth}
                                />
                              ) : (
                                <AssessmentCounterCard
                                  category={category}
                                  title={title}
                                  decimals={decimal}
                                  suffix={suffix}
                                  description={description}
                                  high
                                  bg={
                                    index === 0
                                      ? categoryColor(category).main
                                      : categoryColor(category).main1
                                  }
                                  count={
                                    assessment
                                      .filter((a) => a.region === CurrentRegion)
                                      .filter((y) => y.year === TimeSelected)[0].number
                                  }
                                />
                              )}
                            </Grid2>
                          ))}
                      </Grid2>
                    </Grid2>
                  ))}
                </Grid2>
              </MKBox>
            </Grid2>
          </Grid2>
        </Grid2>
      </MKBox>
    </MainLayout>
  );
};

export default Assessment;
